export const theme = {
  colors: {
    primary: '#F5A623',
    primaryDark: '#E09000',
    primaryLight: '#FFF5E6',
    success: '#2ECC71',
    successDark: '#27AE60',
    white: '#FFFFFF',
    background: '#F7F7F7',
    border: '#E5E5E5',
    textPrimary: '#222222',
    textSecondary: '#666666',
    textTertiary: '#999999',
    stepperGray: '#CCCCCC',
  },
  fonts: {
    family: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  layout: {
    maxWidth: '1200px',
    headerHeight: '64px',
    contentPadding: '0 40px',
    cardRadius: '16px',
    buttonRadius: '50px',
  },
};

export type Theme = typeof theme;
